module.exports = __webpack_public_path__ + "img/goods03.ccbbc90e.png";